// test2485
(2485 && 0);
